import type { ContentLang } from '../editorSlice'

export const LANG_LABEL: Record<ContentLang, string> = { ru: 'Русский', en: 'English' }
